import { createContext, useContext } from 'react';
export var DrawerContext = /*#__PURE__*/createContext(null);
export var useDrawerContext = () => {
  var context = useContext(DrawerContext);

  if (context === null) {
    throw new Error('Drawer components must be wrapped in <Drawer />');
  }

  return context;
};
//# sourceMappingURL=DrawerContext.js.map